package com.essntl.features.client.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.material3.LocalContentColor
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.unit.dp
import com.essntl.features.client.domain.model.ClientModel
import com.essntl.uikit.components.dropdown.EsDropDownMenu
import com.essntl.uikit.components.dropdown.EsDropdownMenuItem
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.icons.EsLargeIcon
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun ClientItem(
    client: ClientModel,
    enabled: Boolean = true,
    isPrimaryClient: Boolean? = null,
    onSetClientPrimary: () -> Unit = {},
    onEditClient: () -> Unit,
    onDeleteClient: () -> Unit,
    modifier: Modifier = Modifier,
) {
    var isDropDownExpanded by remember { mutableStateOf(false) }

    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.SpaceBetween,
        modifier = modifier
            .clip(RoundedCornerShape(16.dp))
            .background(
                color = if (isPrimaryClient != null && isPrimaryClient)
                    Color(0xFFCDC8F9) else
                    MaterialTheme.esColorScheme.bgPrimary,
            )
            .padding(1.5f.spacing),
    ) {
        Row(
            horizontalArrangement = Arrangement.spacedBy(2.5f.spacing),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            if (isPrimaryClient != null && isPrimaryClient)
                EsLargeIcon(
                    res = EsIcons.Crown,
                    tint = if (isPrimaryClient)
                        MaterialTheme.esColorScheme.iconAccent else
                        LocalContentColor.current,
                )

            Column(
                horizontalAlignment = Alignment.Start,
            ) {
                SelectionContainer {
                    Text(
                        text = client.prettyName,
                        style = MaterialTheme.esTypography.p1Medium16.copy(
                            color = if (isPrimaryClient != null && isPrimaryClient)
                                MaterialTheme.esColorScheme.textAccent else
                                MaterialTheme.esTypography.p1Medium16.color,
                        ),
                    )
                }

                val clientAge = rememberClientAge(client.dateOfBirth)

                Text(
                    text = if (clientAge > 0) "$clientAge y.o." else "",
                    style = MaterialTheme.esTypography.p2Regular14.copy(
                        color = if (isPrimaryClient != null && isPrimaryClient)
                            MaterialTheme.esColorScheme.textAccent else
                            MaterialTheme.esColorScheme.textSecondary,
                    ),
                )
            }
        }

        Box {
            EsLargeIcon(
                res = EsIcons.MoreVertical,
                tint = if (isPrimaryClient != null && isPrimaryClient)
                    MaterialTheme.esColorScheme.iconAccent else
                    LocalContentColor.current,
                modifier = Modifier
                    .clip(CircleShape)
                    .pointerHoverIcon(PointerIcon.Hand)
                    .clickable(
                        enabled = enabled,
                    ) {
                        isDropDownExpanded = true
                    },
            )

            EsDropDownMenu(
                expanded = isDropDownExpanded,
                onDismissRequest = { isDropDownExpanded = false },
                modifier = Modifier
                    .width(187.dp),
            ) {
                EsDropdownMenuItem(
                    text = "Edit",
                    prefixIcon = EsIcons.Edit,
                    iconColor = MaterialTheme.esColorScheme.iconPrimary,
                    onClick = {
                        isDropDownExpanded = false
                        onEditClient()
                    },
                    modifier = Modifier.height(40.dp),
                )

                EsDropdownMenuItem(
                    text = "Delete",
                    prefixIcon = EsIcons.Trash,
                    iconColor = MaterialTheme.esColorScheme.iconPrimary,
                    onClick = {
                        isDropDownExpanded = false
                        onDeleteClient()
                    },
                    modifier = Modifier.height(40.dp),
                )

                if (isPrimaryClient != null)
                    EsDropdownMenuItem(
                        text = "Make primary",
                        prefixIcon = EsIcons.Crown,
                        iconColor = if (isPrimaryClient)
                            MaterialTheme.esColorScheme.iconDisabled else
                            MaterialTheme.esColorScheme.iconPrimary,
                        enabled = !isPrimaryClient,
                        onClick = {
                            isDropDownExpanded = false
                            onSetClientPrimary()
                        },
                        modifier = Modifier.height(40.dp),
                    )
            }
        }
    }
}